import { EstateLogFilter } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { ChevronsUpDownIcon } from "@/shared/icons";

export default function EstateHistoryLogsFilter({
  selectedFilter,
  onSelectFilter,
}: {
  selectedFilter: EstateLogFilter;
  onSelectFilter: (filter: EstateLogFilter) => void;
}) {
  const { t } = useTranslation("estate");

  return (
    <div className="flex items-end gap-2 mb-3.5 text-15 text-white/50 leading-0 font-medium">
      <div className="flex items-end gap-2.5">
        <ChevronsUpDownIcon size={12} className="text-white/50 self-center" />
        <p>{t("estate.history.filter")}:</p>
      </div>
      {[EstateLogFilter.All, EstateLogFilter.Fee, EstateLogFilter.Eats, EstateLogFilter.Garage].map(
        (filter) => (
          <button
            key={filter}
            className={clsx(
              "hover:text-white transition-all duration-200 ease-in-out",
              filter === selectedFilter && "text-[#FF4E4E] hover:text-[#FF4E4E]",
            )}
            onClick={() => onSelectFilter(filter)}
            type="button"
          >
            {t(`estate.history.tabs.${filter}`)}
          </button>
        ),
      )}
    </div>
  );
}
